import { IChatDashboardSettings } from './types';

export const getChatDashboardSettingsInitial =
    (): IChatDashboardSettings => {
        const INITIAL: IChatDashboardSettings = {
            enabled: false,
            scope: []
        }
        return INITIAL;
    };
